<div class="max-w-7xl mx-auto space-y-10">
  <!-- Boas-vindas (Card de Indicador: gradiente verde) -->
  <section class="bg-gradient-to-br from-glico-verde to-glico-verde_escuro rounded-2xl p-8 text-white shadow-lg relative overflow-hidden animate-fade-up">
    <svg class="gota-deco absolute -right-6 -bottom-10 w-48 h-48 opacity-20" fill="currentColor" viewBox="0 0 100 100" aria-hidden="true">
      <path d="M50 10C50 10 20 45 20 65C20 81.56 33.43 95 50 95C66.57 95 80 81.56 80 65C80 45 50 10 50 10Z" />
    </svg>
    <div class="relative z-10 flex items-center justify-between gap-6">
      <div>
        <p class="text-glico-verde_claro font-semibold text-sm uppercase tracking-wide m-0 mb-1">{{ hoje }}</p>
        <h1 class="text-3xl md:text-4xl font-extrabold m-0 text-white">Bem-vindo ao Glicosus, {{ nome }}!</h1>
        <p class="mt-3 mb-0 text-glico-verde_claro font-medium max-w-xl">
          Acompanhe as medições dos pacientes, responda aos alertas e mantenha o cuidado em dia.
        </p>
      </div>
      <div class="hidden md:flex bg-white/20 p-4 rounded-2xl backdrop-blur-sm">
        <glico-logo [branco]="true" [comNome]="false" [tamanho]="64" [flutuar]="true"></glico-logo>
      </div>
    </div>
  </section>

  <!-- Atalhos -->
  @if (atalhos.length) {
    <section>
      <h2 class="text-2xl font-bold mb-6 mt-0 flex items-center gap-2 text-glico-texto">
        <span class="w-2 h-6 bg-glico-verde rounded"></span> Acesso rápido
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        @for (atalho of atalhos; track atalho.rota; let i = $index) {
          <a
            [routerLink]="['/', atalho.rota]"
            (click)="navegar(atalho.rota, $event)"
            class="atalho bg-white p-6 rounded-3xl shadow-sm border border-gray-100 flex items-start gap-4 no-underline cursor-pointer"
            [style.--i]="i"
          >
            <div class="icone w-14 h-14 bg-glico-verde_claro rounded-full flex items-center justify-center flex-shrink-0">
              <mat-icon class="text-glico-verde_escuro" [fontIcon]="atalho.icone"></mat-icon>
            </div>
            <div class="flex-1 min-w-0">
              <p class="font-bold text-lg text-glico-texto m-0">{{ atalho.titulo }}</p>
              <p class="text-sm text-gray-500 mt-1 mb-0">{{ atalho.descricao }}</p>
            </div>
            <mat-icon class="seta text-gray-300" fontIcon="arrow_forward"></mat-icon>
          </a>
        }
      </div>
    </section>
  }

  <!-- Legenda de classificação (Badges & Status do manual) -->
  <section class="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 animate-fade-up" style="animation-delay: 300ms">
    <h2 class="font-bold border-b border-gray-100 pb-2 mb-4 mt-0 text-gray-400 uppercase tracking-wider text-sm">
      Classificação das leituras
    </h2>
    <div class="flex flex-wrap gap-3">
      <span class="badge-normal">Normal / Ideal</span>
      <span class="badge-atencao">Leve · Moderado</span>
      <span class="badge-alerta">Crítico · Emergência</span>
    </div>
  </section>
</div>
